import { EndPoints } from "settings/endpoints";
import axiosInstance from "./axios";
import { DEFAULT_TOTAL_RECORDS } from "utils/constants";
import zoneLocalStorageId from "utils/zone";

export const fetchKycData = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  return axiosInstance.get(EndPoints.KYC_VERIFICATION.LIST, {
    params: {
      limit,
      page_no,
      zone_id: zoneLocalStorageId(),
      ...filter,
    },
  });
};

export const createKYCDocumentUpload = (payload) => {
  return axiosInstance.post(EndPoints.KYC_VERIFICATION.CREATE, payload);
};

export const deleteKyc = (id) => {
  const url = `${EndPoints.KYC_VERIFICATION.DELETE}?id=${id}`;
  return axiosInstance.delete(url);
};
